import api from '@/api';

import { API_BASE_URL } from '.';
import {
  CreatePurchaseItemRequest,
  GenerateInvoiceReturnResponse,
  ItemsPurchaseReturnAll,
  PurchaseItem,
  PurchaseItemAddWorkOrderItems,
  PurchaseItemSellPriceUpdateRequest,
  PurchaseItemTagsData,
  PurchaseItemUpdateByPartId,
  PurchaseItemWorkOrderLink,
  PurchaseRemoveRequest,
  ReturnItemGenerateInvoiceRequest,
  ReturnItemQuery,
  UpdatePurchaseItemRequest,
} from './PurchaseItem.types';
import { PageRequest } from '@/core/request/PageRequest';
import { PageResult } from '@/core/request/PageResult';

const CONTROLLER_URL = `${API_BASE_URL}/purchases`;

export async function purchasesItemsList(params?: PageRequest) {
  const result = (await api.get(`${CONTROLLER_URL}/itens`, params)) as unknown;

  return result as PageResult<PurchaseItem>;
}

export async function purchaseItemCreate(
  obj: CreatePurchaseItemRequest,
): Promise<PurchaseItem> {
  const result = (await api.post(
    `${CONTROLLER_URL}/itens`,
    obj,
    null,
  )) as unknown;

  return result as PurchaseItem;
}

export async function purchaseItemListCreate(
  obj: CreatePurchaseItemRequest[],
): Promise<PurchaseItem[]> {
  const result = (await api.post(
    `${CONTROLLER_URL}/itens/list`,
    obj,
    null,
  )) as unknown;

  return result as PurchaseItem[];
}

export async function purchaseItemUpdate(
  obj: UpdatePurchaseItemRequest,
): Promise<PurchaseItem> {
  const result = (await api.put(
    `${CONTROLLER_URL}/itens`,
    obj,
    null,
  )) as unknown;

  return result as PurchaseItem;
}

export async function getPurchaseItem(id: number) {
  const result = (await api.get(
    `${CONTROLLER_URL}/itens/${id}`,
    {},
  )) as unknown;

  return result as PurchaseItem;
}

export async function itemPurchaseRemove(obj: PurchaseRemoveRequest) {
  const result = (await api.remove(
    `${CONTROLLER_URL}/itens/${obj.id}`,
    {},
    null,
  )) as unknown;

  return result;
}

export async function calculateTaxesItemPurchase(
  obj: UpdatePurchaseItemRequest,
) {
  const result = (await api.put(
    `${CONTROLLER_URL}/itens/calc-taxes`,
    obj,
    null,
  )) as unknown;

  return result as PurchaseItem;
}

export async function listItemPurchasesReturn(
  params: ReturnItemQuery,
): Promise<PageResult<PurchaseItem>> {
  const result = (await api.get(
    `${CONTROLLER_URL}/itens/return`,
    params,
  )) as unknown;
  return result as PageResult<PurchaseItem>;
}

export async function itemPurchaseReturnGenerateInvoice(
  obj: ReturnItemGenerateInvoiceRequest,
) {
  const result = (await api.post(
    `${CONTROLLER_URL}/itens/return`,
    obj,
    null,
  )) as unknown;

  return result as GenerateInvoiceReturnResponse;
}

export async function purchasesReturnAllItemsList(params?: PageRequest) {
  const result = (await api.get(
    `${CONTROLLER_URL}/itens/return/all`,
    params,
  )) as unknown;

  return result as PageResult<ItemsPurchaseReturnAll>;
}

export async function getPurchaseItemsTags(purchaseId: number) {
  const result = (await api.get(`${CONTROLLER_URL}/itens/tags`, {
    purchaseId,
  })) as unknown;

  return result as PurchaseItemTagsData;
}

export async function purchaseItemsSellPriceUpdate(
  data: PurchaseItemSellPriceUpdateRequest[],
) {
  const result = (await api.patch(
    `${CONTROLLER_URL}/itens/update-sell-price`,
    data,
    null,
  )) as unknown;

  return result as void;
}

export async function purchaseItemsUpdateByPartId({
  purchaseItemId,
  ...payload
}: PurchaseItemUpdateByPartId) {
  const result = (await api.patch(
    `${CONTROLLER_URL}/itens/${purchaseItemId}/part-id`,
    payload,
    null,
  )) as unknown;

  return result as void;
}

export async function purchaseItemsWorkOrderLink(
  payload: PurchaseItemWorkOrderLink,
) {
  const result = (await api.patch(
    `${CONTROLLER_URL}/itens/work-order-link`,
    payload,
    null,
  )) as unknown;

  return result as void;
}

export async function purchaseItemsRemoveWorkOrderLink(purchaseItemId: number) {
  const result = (await api.remove(
    `${CONTROLLER_URL}/itens/${purchaseItemId}/work-order-link`,
    {},
    null,
  )) as unknown;

  return result as void;
}

export async function purchaseItemsAddWorkOrderItems(
  payload: PurchaseItemAddWorkOrderItems,
) {
  const result = (await api.post(
    `${CONTROLLER_URL}/itens/work-order-items`,
    payload,
  )) as unknown;

  return result as void;
}

export async function purchaseItemCreatePart(purchaseItemId: number) {
  const result = (await api.post(
    `${CONTROLLER_URL}/itens/${purchaseItemId}/create-part`,
    {},
  )) as unknown;

  return result as void;
}
